module.exports = __webpack_public_path__ + "img/banner.ef14c89f.png";